import { c as _c } from "react/compiler-runtime";
import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useIsBrowser from 'hooks/useIsBrowser';
import { GET_RESOLVED_WAREHOUSE_ID } from 'mocks/queries';
const DEFAULT_VALUE = {
  error: undefined,
  loading: false,
  refetch: () => {},
  warehouseId: DEFAULT_WAREHOUSE_ID
};
const ZIP_CODE_PATTERN = /^\d{5}$/;

// Alexandria's SanitizedZipCodeInputString rejects anything that is not five
// digits with a BAD_USER_INPUT error. Callers pass unnormalised values (a
// CloudFront postal_code can be ZIP+4), and an errored query would suppress the
// whole location in useLocationFromCloudFront - not just the warehouse - so
// screen the zip here instead of letting the scalar throw.
const normalizeZip = value => {
  const zip = String(value ?? '').trim().slice(0, 5);
  return ZIP_CODE_PATTERN.test(zip) ? zip : undefined;
};

// Resolves through Alexandria's cached chain, the same one SSR uses via
// getWarehouseIdForRequest, so the server and the client cannot disagree and
// flip the warehouse after hydration. (CON-8558)
const useWarehouseIdForZipCode = zipcode => {
  const $ = _c(12);
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] !== zipcode) {
    t0 = normalizeZip(zipcode);
    $[0] = zipcode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sanitizedZipcode = t0;
  let t1;
  if ($[2] !== sanitizedZipcode) {
    t1 = {
      zipcode: sanitizedZipcode
    };
    $[2] = sanitizedZipcode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !sanitizedZipcode;
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data,
    error,
    loading,
    refetch
  } = useSuspenseQuery(GET_RESOLVED_WAREHOUSE_ID, t3);
  if (!sanitizedZipcode || !isBrowser || !data?.getResolvedWarehouseId) {
    return DEFAULT_VALUE;
  }
  const t4 = loading && !data;
  let t5;
  if ($[7] !== data.getResolvedWarehouseId || $[8] !== error || $[9] !== refetch || $[10] !== t4) {
    t5 = {
      error,
      loading: t4,
      refetch,
      warehouseId: data.getResolvedWarehouseId
    };
    $[7] = data.getResolvedWarehouseId;
    $[8] = error;
    $[9] = refetch;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default useWarehouseIdForZipCode;